import {
  CRUDLayout
} from "components"
import {
  ButtonBack,
  ButtonCreate
} from "components2"
import { Form, Formik } from "formik"
import { useModalConfirm } from "hooks2"
import { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { IoWarning } from "react-icons/io5"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import * as Yup from "yup"
import PermintaanPerubahaDataApi from "./api/PermintaanPerubahaDataApi"
import { FormPermintaanPerubahanData, ListPerubahanData } from "./components"
import { ModalFormItemPerubahanData } from "./components/ModalFormItemPerubahanData"
import { submitMapper } from "./utils/submitMapper"

export const PermintaanPerubahaDataCreate = ({ setNavbarTitle }) => {
  const today = new Date()
  const history = useHistory()
  const modalConfirm = useModalConfirm()
  const [modal, setModal] = useState({
    type: "CREATE",
    show: false,
    data: null,
    index: null
  })

  const onCreateButtonClickHandler = () => setModal({ show: true, type: "CREATE", data: null, index: null })

  const dismissModal = (resetForm) => {
    resetForm()
    setModal({ data: null, index: null, show: false, type: "" })
  }

  const formInitialValues = {
    tgl_permintaan_perubahan_data_master: today.toISOString().split("T")[0],
    no_permintaan_perubahan_data_master: "",
    urgensi: "",
    deskripsi: "",
    detail: []
  }

  const onSubmitForm = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true)

    await modalConfirm.trigger({
      type: 'create',
      customTextHeader: ' ',
      title: 'Konfirmasi pengubahan data?',
      component: (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <IoWarning size={100} className="mb-1 text-danger" />
          <div className="mb-3 d-flex flex-column align-items-center justify-content-center">
            <small
              className="font-weight-bold"
              style={{ fontSize: 14, color: 'var(--bs-danger)' }}>
              Apakah anda yakin ingin membuat permintaan ini?
            </small>
          </div>
        </div>
      ),
      onSubmit: async () => {
        modalConfirm.loading()

        const finalValue = submitMapper(values)

        PermintaanPerubahaDataApi.create(finalValue)
          .then(() =>
            modalConfirm.infoSuccess({
              title: 'Data permintaan berhasil dibuat',
              customTextInfoDetail: 'Data telah tersimpan ke database',
              size: 'md',
              onHide: () => {
                resetForm()
                modalConfirm.close()
                history.replace(
                  '/human-resource/support/permintaan-pengubahan-data'
                )
              },
            })
          )
          .catch(({ response }) => {
            modalConfirm.infoError({
              title: 'Permintaan gagal dibuat',
              customTextInfoTitle: 'Penyebab Kegagalan:',
              customTextInfoDetail: response?.data?.message,
            })
          })
      },
      onHide: () => modalConfirm.close(),
    })
  }

  useEffect(() => setNavbarTitle("Permintaan Perubahan Data"), [])

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadButtonSection>
          <ButtonBack size="md" icon onClick={() => history.goBack()} />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      <Formik
        enableReinitialize
        validationSchema={Yup.object().shape({
          tgl_permintaan_perubahan_data_master: Yup.string().required("Required"),
          urgensi: Yup.string().required("Required"),
          deskripsi: Yup.string().required("Required"),
          detail: Yup.array().min(1, "Required"),
        })}
        initialValues={formInitialValues}
        onSubmit={onSubmitForm}
      >
        {({ values, handleSubmit, isSubmitting, setValues, errors, touched }) => {
          const onCreateItem = (value, helpers) => {
            setValues(prev => ({ ...prev, detail: [...prev.detail, value] }))
            dismissModal(helpers.resetForm)
          }

          const onUpdateItem = (value, helpers) => {
            const updatedDetail = [...values.detail]
            updatedDetail.splice(modal.index, 1, value)
            setValues(prev => ({ ...prev, detail: updatedDetail }))
            dismissModal(helpers.resetForm)
          }

          const onDeleteItem = (_value, index) => {
            setValues(prev => ({ ...prev, detail: prev.detail.filter((_, i) => i !== index) }))
          }

          return (
            <Form>
              <Card className="mt-4">
                <Card.Body>
                  <FormPermintaanPerubahanData />
                </Card.Body>
              </Card>

              <Card className="mt-4">
                <Card.Header className="font-weight-bold">List Perubahan Data</Card.Header>
                <Card.Body>
                  <div className="d-flex justify-content-end align-items-center mb-3">
                    <ButtonCreate icon text="Tambah Perubahan Data" onClick={onCreateButtonClickHandler} />
                  </div>

                  <ListPerubahanData
                    data={values.detail}
                    onClickUpdate={(data, index) => setModal({ show: true, type: "UPDATE", data, index })}
                    onClickDelete={onDeleteItem}
                  />

                  <div style={{ marginTop: -15 }}>
                    {errors.detail && touched.detail && (<small className="text-danger ">{errors.detail}</small>)}
                  </div>

                  <div className="d-flex justify-content-end align-items-center mt-4">
                    <ButtonCreate
                      text="Ajukan"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                      onClick={handleSubmit}
                    />
                  </div>
                </Card.Body>
              </Card>

              <ModalFormItemPerubahanData
                modal={modal}
                dismissModal={dismissModal}
                onCreateItem={onCreateItem}
                onUpdateItem={onUpdateItem}
              />
            </Form>
          )
        }}
      </Formik>
    </CRUDLayout >
  )
}
